import { createApp } from 'vue';
import TgsToGifConverter from '@/Components/TgsToGifConverter.vue';
import '@styles/app.css';

createApp(TgsToGifConverter).mount('#tgs-to-gif-converter');
